export default __webpack_public_path__ + "static/media/SchoolBus.c4c350ae.webp";